export enum EventCollisionModalResponseEnum {
  MergeEvents,
  DoNotMergeEvents
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/event-collision-modal/event-collision-modal-response.enum.ts